module.exports = __webpack_public_path__ + "img/success_OLD_5.63580499.gif";